import { createAction } from '@reduxjs/toolkit';

type LDFlags = {
  keys: string[];
  values: { value: boolean | { [key: string]: string } }[];
};

export const fetchFeatureFlags = createAction<{ clientId: string; countryCode: string }>('FETCH_FEATURE_FLAGS');

export const receiveFeatureFlags = createAction<LDFlags>('RECEIVE_FEATURE_FLAGS');

export const rejectFeatureFlags = createAction('flags/REJECT_FEATURE_FLAGS');
